import { ChevronRightIcon } from '@heroicons/react/solid'
import { Fragment } from 'react'
import { Paragraph } from '../Typography'

type Props = {
  path: string
}

export function LocationInfo(props: Props) {
  return (
    <Paragraph className="ml-auto !text-sm font-semibold !text-slate-500">
      {props.path.split('/').map((item, index) => (
        <Fragment key={index}>
          {index !== 0 && (
            <ChevronRightIcon className="inline w-5 h-5 text-slate-300" />
          )}
          {item}
        </Fragment>
      ))}
    </Paragraph>
  )
}
